'use client';

import { useState } from 'react';
import FooterInfo from './footer/FooterInfo';
import FooterLinks from './footer/FooterLinks';
import FooterSocial from './footer/FooterSocial';
import FooterLogo from './footer/FooterLogo';
import TermsModal from './modals/TermsModal';
import PrivacyModal from './modals/PrivacyModal';

export default function Footer() {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  
  const openTermsModal = () => {
    setIsTermsModalOpen(true);
  };

  const closeTermsModal = () => {
    setIsTermsModalOpen(false);
  };

  const openPrivacyModal = () => {
    setIsPrivacyModalOpen(true);
  };

  const closePrivacyModal = () => {
    setIsPrivacyModalOpen(false);
  };

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        {/* 로고 중앙 배치 */}
        <div className="flex justify-center mb-10">
          <FooterLogo />
        </div>

        {/* 링크 메뉴 상단 배치 및 가운데 정렬 */}
        <div className="flex justify-center space-x-6 mb-10">
          <button 
            onClick={openTermsModal} 
            className="hover:text-white cursor-pointer"
          >
            이용약관
          </button>
          <button 
            onClick={openPrivacyModal} 
            className="hover:text-white cursor-pointer"
          >
            개인정보처리방침
          </button>
        </div>
        
        {/* 이용약관 모달 */}
        <TermsModal isOpen={isTermsModalOpen} onClose={closeTermsModal} />
        
        {/* 개인정보처리방침 모달 */}
        <PrivacyModal isOpen={isPrivacyModalOpen} onClose={closePrivacyModal} />
        
        {/* 회사 정보 섬션 */}
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-center gap-4 mb-10">
          <FooterInfo />
          <div className="md:flex gap-12">
            <FooterLinks />
            <FooterSocial />
          </div>
        </div>

        {/* 코피라이트 */}
        <div className="border-t border-gray-800 mt-10 pt-6 text-gray-400">
          <div className="flex justify-center items-center">
            <div>
              © Donki.Inc {new Date().getFullYear()} All Rights Reserved
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
} 